import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/dave/checkouts/pyohio/static-website/node_modules/gatsby-theme-catalyst-core/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Seo = makeShortcode("Seo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Seo title="PyOhio 2022 Registration" mdxType="Seo" />
    <h1 {...{
      "id": "register-for-pyohio"
    }}>{`Register for PyOhio`}</h1>
    <ul>
      <li parentName="ul">{`Registration is free! `}<a parentName="li" {...{
          "href": "https://ti.to/pyohio/2022",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`Register here!`}</a></li>
      <li parentName="ul">{`T-shirt sales benefit The Python Software Foundation. `}<a parentName="li" {...{
          "href": "https://www.customink.com/fundraising/pyohio-2022",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`Buy a t-shirt`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      